import React from 'react';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';
import styles from './UserMatchScores.module.scss';

const TRUNCATE_AT = 80;

const truncate = (value) => {
  if (value == null) return '';
  const str = String(value);
  return str.length > TRUNCATE_AT ? str.slice(0, TRUNCATE_AT) : str;
};

const formatGate = (gate) => {
  if (gate == null || gate === '') return null;
  return String(gate).replace(/_/g, ' ');
};

const matchedAttribute = (line) => {
  if (line.userAttributeType == null && line.userAttributeValue == null) {
    return { display: '—', title: undefined };
  }
  const fullValue = line.userAttributeValue == null ? '' : String(line.userAttributeValue);
  return {
    display: `${line.userAttributeType}: ${truncate(fullValue)}`,
    title: `${line.userAttributeType}: ${fullValue}`,
  };
};

const UserMatchScoresBreakdown = ({ score }) => {
  const unmetRequired = score?.unmetRequired || [];
  const breakdown = Array.isArray(score?.breakdown) ? score.breakdown : [];
  const sortedBreakdown = [...breakdown].sort((a, b) => {
    const aScore = Number(a?.importanceScore) || 0;
    const bScore = Number(b?.importanceScore) || 0;
    return bScore - aScore;
  });

  return (
    <div className={styles.expandedPanel}>
      {unmetRequired.length > 0 && (
        <div className={styles.expandedGaps}>
          {unmetRequired.map((item, index) => {
            const fullText = item?.text == null ? '' : String(item.text);
            const gate = formatGate(item?.gate);
            return (
              <div key={index} className={styles.gapLine} title={fullText}>
                {`Missing required: ${truncate(fullText)}`}
                {gate && <span className={styles.gateMuted}>{gate}</span>}
              </div>
            );
          })}
        </div>
      )}

      {sortedBreakdown.length === 0 ? (
        <p className={styles.emptyBreakdown}>
          No line breakdown stored (this score was computed before breakdown storage).
        </p>
      ) : (
        <Table>
          <Thead>
            <Tr>
              <Th>Importance</Th>
              <Th>Category</Th>
              <Th>JD line</Th>
              <Th>Matched attribute</Th>
              <Th>Line score</Th>
            </Tr>
          </Thead>
          <Tbody>
            {sortedBreakdown.map((line, index) => {
              const lineText = line?.lineText == null ? '' : String(line.lineText);
              const attribute = matchedAttribute(line);
              return (
                <Tr key={index}>
                  <Td>{line?.importanceScore ?? '—'}</Td>
                  <Td>{line?.importanceCategory || '—'}</Td>
                  <Td title={lineText}>{truncate(lineText) || '—'}</Td>
                  <Td title={attribute.title}>{attribute.display}</Td>
                  <Td>{line?.matchScore ?? '—'}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      )}
    </div>
  );
};

export default UserMatchScoresBreakdown;
